import { createSlice } from '@reduxjs/toolkit';
import { ClientErrorsState } from './client-errors.state';
import { fetchClientErrorReports } from './thunks/fetch-client-error-reports.thunk';
import { setClientErrorResolution } from './thunks/set-client-error-resolution.thunk';

const initialState: ClientErrorsState = {
    items: [],
    totalCount: 0,
    isLoading: false,
    status: 'succeeded',
    error: '',
};

const clientErrorsSlice = createSlice({
    name: 'clientErrors',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchClientErrorReports.pending, (state) => setPendingState(state))
            .addCase(fetchClientErrorReports.fulfilled, (state, action) => {
                state.items = action.payload.items;
                state.totalCount = action.payload.totalCount;
                setSucceededState(state);
            })
            .addCase(fetchClientErrorReports.rejected, (state) => setRejectedState(state))
            .addCase(setClientErrorResolution.fulfilled, (state, action) => {
                state.items = state.items.filter((item) => item.id !== action.payload.id);
                state.totalCount = Math.max(0, state.totalCount - 1);
            });
    },
});

const setRejectedState = (state: any) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = state;
};

const setPendingState = (state: any) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: any) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};

export const {} = clientErrorsSlice.actions;
export default clientErrorsSlice.reducer;
